import { fillSegments } from 'modules/route/route';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useHasMultipleTenants } from 'state/user';
import { useWidgets } from 'state/widget/widget';
import NoWidgetsView from './Views/NoWidgetsView';
import { ROUTES, Segments } from './Views/routes';
import TenantSelectorView from './Views/TenantSelectorView';
import WidgetView from './Views/WidgetView';

const AppRoutes: React.FC = () => {
	const widgets = useWidgets();
	const hasMultipleTenants = useHasMultipleTenants();

	if (widgets && widgets.length === 0) {
		return (
			<Routes>
				<Route path="*" element={<NoWidgetsView />} />
			</Routes>
		);
	}

	return (
		<Routes>
			{widgets?.length &&
				widgets.map((widget) => (
					<Route
						key={widget.id}
						path={fillSegments(ROUTES.widget, {
							[Segments.WidgetPath]: widget.path
						})}
						element={<WidgetView widget={widget} />}
					/>
				))}
			{hasMultipleTenants && (
				<Route path={ROUTES.tenantSelect} element={<TenantSelectorView />} />
			)}
			{/* fallback to first widget */}
			{widgets?.length && (
				<Route
					path="*"
					element={
						<Navigate
							to={fillSegments(ROUTES.widget, {
								[Segments.WidgetPath]: widgets[0].path
							})}
							replace
						/>
					}
				/>
			)}
		</Routes>
	);
};

export default AppRoutes;
